/*
 * @Author: lan.h
 * @Date: 2021-10-14 09:39:50
 * @LastEditors: lan.h
 * @LastEditTime: 2021-12-01 11:37:01
 * @Description: 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import {getMeta} from '@/service/main.js'

Vue.use(VueRouter)

const main = () => import(/* webpackChunkName: "main" */ '../views/main/main.vue')
const index = () => import(/* webpackChunkName: "main" */ '../views/main/index.vue')
const report = () => import(/* webpackChunkName: "main" */ '../views/main/report.vue')
const vb100List = () => import(/* webpackChunkName: "main" */ '../views/main/vb100List.vue')
const pcAward = () => import(/* webpackChunkName: "main" */ '../views/main/pc_award.vue')
const oAward = () => import(/* webpackChunkName: "main" */ '../views/main/o_award.vue')
const wlAward = () => import(/* webpackChunkName: "main" */ '../views/main/wl_award.vue')
const org = () => import(/* webpackChunkName: "main" */ '../views/main/org.vue')
const release = () => import(/* webpackChunkName: "main" */ '../views/main/release.vue')
const wAward = () => import(/* webpackChunkName: "main" */ '../views/main/v_award.vue')
const innovateAward = () => import(/* webpackChunkName: "main" */ '../views/main/innovate_award.vue')
const declare = () => import(/* webpackChunkName: "main" */ '../views/main/declare.vue')

const routes = [
  { path: '/', name: 'index', component: index },
  {
    path: '/',
    name: 'main',
    component: main,
    children: [
      { path: 'report', name: 'report', component: report },
      { path: 'vb100List', name: 'vb100List', component: vb100List },
      { path: 'pcAward', name: 'pcAward', component: pcAward },
      { path: 'innovateAward', name: 'innovateAward', component: innovateAward },
      { path: 'oAward', name: 'oAward', component: oAward },
      { path: 'wlAward', name: 'wlAward', component: wlAward },
      { path: 'org', name: 'org', component: org },
      { path: 'release', name: 'release', component: release },
      { path: 'wAward', name: 'wAward', component: wAward },
      { path: 'declare', name: 'declare', component: declare }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: '',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  if (!store.state.is_pc) { // 如果
    // alert(window.location.protocol + '//' + window.location.host + '/mindex'+ to.fullPath)
    window.location.href = window.location.protocol + '//' + window.location.host + '/mindex'+ to.fullPath
  } else {
    if (!store.state.list_meta) { 
      let res = await getMeta({}, (error) => {
        console.log('请求错误！')
      })
      if (res.status == 'success') { 
        store.commit('getMeta', res)
      }
      next()
    } else {
      next()
    }
    
  }
  
 
})

export default router
